import Card from "../../components/Card";

function SecondPage() {
  return (
    <div>
      <div className="w-[80%] mx-auto  py-12">
        <div id="container" className="flex flex-col gap-y-52">
            <div className="flex flex-col items-center justify-center above-1100:flex-row gap-12 w-[80%] mx-auto">
             <Card
  image="/images/create.png"
  title="Create"
  text="Start by creating your account in seconds, it's quick, simple, and absolutely free to get going."
/>
<Card
  image="/images/login.png"
  title="Login"
  text="Log in securely anytime, anywhere. Your data stays safe while you stay in control of everything."
/>
<Card
  image="/images/manage.png"
  title="Manage"
  text="Easily manage your tasks, track progress, and stay organized with all tools in one clean dashboard."
/>

            </div>
              <div className="flex flex-col justify-center items-center gap-9 ">
              <h1 className="max-w-[50rem] text-4xl sm:text-5xl font-extrabold sm:leading-tight text-white text-center">
                A crypto mining platform that invest in you
              </h1>
              <p className="text-gray-500 text-center max-w-[45rem]">
                Join a next gen mining ecosystem designed for beginners and pros, secure, scalable, and built for real growth with genuine intrest.
              </p>
              <button className="text-white py-4 px-6 bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer hover:translate-y-2">
                Get Started
              </button>
            </div>
        </div>
        <img src="/images/new-start-eight.png" alt="" className="relative w-6 sm:w-10 sm:left-[10%] sm:top-3"/>
        <img src="/images/star-six-sided.png" alt="" className="w-16 sm:w-auto"/>
      </div>
    </div>
  );
}

export default SecondPage;
